<template>
    <div class="container santi-tabs">
        <div class="row justify-content-center">
            <div class="col-4 pl-0 pr-0 col-md-2">
                <a v-on:click="changeSanti(1)" :class="(santiOption == 1 ? 'active' : '')">
                    <img src="/img/santi.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Santi</span></a>
            </div>
            <div class="col-4 pl-0 pr-0 col-md-2">
                <a v-on:click="changeSanti(2)" :class="(santiOption == 2 ? 'active' : '')">
                    <img src="/img/santi-guru.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Gurú Turístico</span>
                </a>
            </div>
            <div class="col-4 pl-0 pr-0 col-md-2">
                <a v-on:click="changeSanti(3)" :class="(santiOption == 3 ? 'active' : '')">
                    <img src="/img/santi-asistente.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Asistente</span>
                </a>
            </div>
            <div class="col-4 pl-0 pr-0  col-md-2">
                <a v-on:click="changeSanti(4)" :class="(santiOption == 4 ? 'active' : '')">
                    <img src="/img/santi-ecologico.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Ecológico</span>
                </a>
            </div>
            <div class="col-4 pl-0 pr-0  col-md-2">
                <a v-on:click="changeSanti(5)" :class="(santiOption == 5 ? 'active' : '')">
                    <img src="/img/santi-trabajo.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Jale</span>
                </a>
            </div>
            <div class="col-4 pl-0 pr-0  col-md-2">
                <a v-on:click="changeSanti(6)" :class="(santiOption == 6 ? 'active' : '')">
                    <img src="/img/santi-vial.png" alt="Santi" loading="lazy" width="95" height="95" /><span class="d-block d-lg-inline-block">Asistente Vial</span>
                </a>
            </div>
        </div>
    </div>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas" v-if="santiOption == 1">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi.png" alt="Santi" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Sistema de Atención Integral</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>Santi es el vínculo entre la ciudadanía y la Secretaría de Servicios Públicos para el reporte y seguimiento de las solicitudes de atención de los vecinos santiaguenses.</p>
                            <br>
                            <p><b>Conoce los pasos para realizar un trámite o reporte</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Atención rápida y oportuna 24/7</div>
                            <div class="list-checks__item">Seguimiento personalizado de los reportes</div>
                            <div class="list-checks__item">Solución efectiva en un plazo de 48 horas</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡Contacta a Santi!</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Puedes hacerlo vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a>, en <a href="/santibot" target="_blank">línea</a> o por <a href="tel:81 2285 2582">teléfono</a> a la Secretaría de Servicios Públicos al <b>81 2285 2582</b>. Para tu reporte deberás contar con la ubicación exacta, explicar de forma precisa la problemática y enviar fotos.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">¿Cómo dar seguimiento?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Santi te brindará un número de folio y un enlace donde podrás verificar de forma directa el cambio de estatus conforme a las actividades y soluciones ejecutadas por parte de Servicios Públicos.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">Santi te notificará la solución a tu reporte</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Una vez atendida tu petición, Santi te informará de inmediato vía <b>WhatsApp, correo electrónico</b> o por el medio que hayas elegido el cierre de tu reporte.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas santi-guru" v-if="santiOption == 2">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi-guru.png" alt="Santi guru" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Gurú Turístico</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>Hola, soy Santi y seré tu gurú turístico virtual. Ahora, descubre Santiago a través de WhatsApp.</p>
                            <br>
                            <p><b>Conoce los pasos</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Información de lugares qué visitar. </div>
                            <div class="list-checks__item">Guía de mapas para conocer los destinos y rutas. </div>
                            <div class="list-checks__item">Santi te comparte detalles como ubicación, redes sociales y fotos de los lugares más recomendados.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡Contacta a Santi! Indica que te gustaría visitar</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>
                                    Puedes hacerlo vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a>, en el <a href="/santibot" target="_blank">Portal Oficial del Municipio</a>,
                                    o escaneando el código QR de Santi. Una vez que le indicas lo que deseas visitar,
                                    ya sea museos, restaurantes, lugares de interés o
                                    eventos, Santi te enviará un mensaje con los datos, redes, mapa e información del lugar que buscas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">¿Tiénes un restaurante y deseas que aparezca aquí?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Entra a: <a href="https://santiago.gob.mx/directorio-restaurantes">https://santiago.gob.mx/directorio-restaurantes</a> y de manera sencilla comparte la información de tu restaurante para formar parte las recomendaciones que Santi Gurú Turístico ofrecerá a quienes lo consultan para disfrutar de nuestro Municipio.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">¿Quiéres ser parte del directorio turístico?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Para registrar tu negocio como tours operadores, hoteles, cabañas y estacionamientos, contacta a la Dirección General de Turismo y Eventos <a href="mailto:guiaturistica@santiago.gob.mx ">guiaturistica@santiago.gob.mx</a> para compartir tu información general y de interés.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas santi-asistente" v-if="(santiOption == 3)">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi-asistente.png" alt="Santi Asistente" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Soy tu Asistente</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>¡Hola! Soy Santi y seré tu asistente virtual si necesitas consultar o pagar tu predial o multas, es muy fácil.</p>
                            <br>
                            <p><b>Conoce los pasos</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Consulta tu Predial.</div>
                            <div class="list-checks__item">Consulta tus Multas. </div>
                            <div class="list-checks__item">Paga tus multas o tu predial.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡Contacta a Santi!, Tu asistente virtual</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Puedes hacerlo vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a>, en aquí mismo en nuestro <a href="/santibot" target="_blank">Portal Oficial del Municipio </a>, o escaneando el código QR de Santi.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">¿En qué te puedo ayudar?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Indica la opción que necesitas consultar, opción 3 para multas y la opción 4 para predial; y sigue los pasos de consulta o pago de forma rápida y sencilla.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">¿Quiéres realizar el pago de multas o predial?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>No te preocupes <span class="destacado">es muy seguro</span> y muy sencillo, sólo sigues los pasos para el pago que sean indicados y listo, estarás al corriente.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas santi-ecologico" v-if="(santiOption == 4)">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi-ecologico.png" alt="Santi Ecologico" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Ecológico</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>¡Hola! Soy Santi Ecológico y seré tu asistente virtual si necesitas reportar, cualquier acción, evento o falta que pueda causar un desequilibrio ecológico, es muy fácil.</p>
                            <br>
                            <p><b>Conoce los pasos</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Garantiza protección y respeto a los derechos animales.</div>
                            <div class="list-checks__item">Permanentes inspecciones y rondines para detección de posibles actos de infracción en contra de nuestro medio ambiente.</div>
                            <div class="list-checks__item">48 horas en la atención e inspección de los reportes.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡En Santiago ¡decimos si a la vida!</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Puedes hacer tu reporte vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a>, en aquí mismo en nuestro <a href="/santibot" target="_blank">Portal Oficial del Municipio </a> escaneando el código QR de Santi o ante la Dirección General de Protección al Medio Ambiente y Bienestar Animal al teléfono 81 2285 3049 ext. 2170 para actos en contra al medio ambiente o el cuidado animal.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">¿Qué puedes reportar?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>En whatsapp elige Santi Ecológico y selecciona la opción para interponer reportes para la afectación de árboles, cuidado animal, contaminación ambiental y al suelo, así como la contaminación del agua.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">Santi Ecológico</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>En un lapso de 48 horas el personal operativo realizará inspecciones para determinar cualquier acción, evento o falta que pueda causar un desequilibrio ecológico, dañar el medio ambiente o los recursos naturales del municipio.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas santi-jale" v-if="(santiOption == 5)">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi-trabajo.png" alt="Santi Ecologico" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Jale</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>Hola, soy Santi Jale. ¿Buscas alguna oferta de trabajo?, te ayudaré a encontrar la mejor opción en nuestra Bolsa de Trabajo. Envíame un WhatsApp, regístrate y recibe las mejores opciones de empleo.</p>
                            <br>
                            <p><b>Conoce los pasos</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Más de 20 opciones de empleo.</div>
                            <div class="list-checks__item">Desde oficios hasta profesiones.</div>
                            <div class="list-checks__item">Santi te ayuda a contactar a los empleadores.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡Contacta a Santi! Indica que buscas jale</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Puedes hacerlo vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a> o en el <a href="/santibot" target="_blank">Portal Oficial del Municipio</a>. Una vez que seleccionas la opción 6, Bolsa de Empleo, aquí puedes buscar por categorías o por palabras clave.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">Regístrate</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Es muy importante que te registres, sigue los pasos que te marca, son muy sencillos. Hay muchas empresas locales y foráneas que ofertan vacantes tanto de planta como temporal.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">¿Por qué es necesario registrarme?</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Esto hace más fácil la búsqueda de empleos que reúnen las características que buscas, o sea que te dará las opciones que más se apegan a tu solicitud. Además, de esta manera sigues recibiendo opciones de trabajo hasta que encuentres una.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <Transition mode="out-in">
        <div class="bloque-general bloque-flechas-rojas santi-vial" v-if="(santiOption == 6)">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-7">
                        <div class="encabezado-santi">
                            <img src="/img/santi-vial.png" alt="Santi Ecologico" loading="lazy" width="190" height="190">
                            <h2>Santi - <span>Asistente Vial</span></h2>
                        </div>
                        <div class="contenido-administrable contenido-administrable--santi">
                            <p>Hola, soy Santi Asistente Vial. Soy un canal de fácil interacción entre la comunidad y este gobierno para la consulta y pagos en línea de multas de tránsito.</p>
                            <br>
                            <p><b>Conoce los pasos</b> <span class="destacado">¡Es muy sencillo!</span></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-5">
                        <div class="list-checks">
                            <div class="list-checks__item">Consulta tus multas pendientes.</div>
                            <div class="list-checks__item">Paga en línea sin tener que salir de casa.</div>
                            <div class="list-checks__item">Sólo requieres la placa de tu vehículo.</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">01</div>
                            <h3 class="columna-pasos__titulo">¡Contacta a Santi Asistente Administrativo! </h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Puedes hacerlo vía <a href="https://www.santiago.gob.mx/santi" target="_blank">WhatsApp</a> o en el <a href="/santibot" target="_blank">Portal Oficial del Municipio</a>.  Para conocer las multas pendientes de pago, deberás elegir la opción 3.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">02</div>
                            <h3 class="columna-pasos__titulo">Consulta las multas</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Santi Asistente Administrativo te pedirá que escribas el número de placa de tu vehículo y desplegará la información de sanciones pendientes.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="columna-pasos">
                            <div class="columna-pasos__numero">03</div>
                            <h3 class="columna-pasos__titulo">Paga en línea</h3>
                            <div class="contenido-administrable contenido-administrable--santi">
                                <p>Sigue las indicaciones de Santi para pagar en línea las multas que le han sido aplicadas a tu vehículo. Todo desde la comodidad de tu hogar o tu oficina sin tener que desplazarte y gastar tiempo.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script>
export default {
    data: () => {
        return {
            santiOption: 1
        }
    },
    methods: {
        changeSanti(number) {
            this.santiOption = number;
        }
    }
}
</script>
<style>
.destacado {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 700;
    color: #F25D58;
    text-decoration: none;
    word-break: break-word;
}

.columna-pasos__titulo {
    line-height: 1.3em;
    margin-bottom: 20px;
}

.santi-guru .encabezado-santi span {
    color: #85D6E6;
}
.bloque-flechas-rojas.santi-guru::before {
    background-image: url(/img/adorno-flecha-izq-azul.png);
}

.bloque-flechas-rojas.santi-guru::after {
    background-image: url(/img/adorno-flecha-der-azul.png);
}

.santi-guru .list-checks__item::before {
    background-image: url(/img/icono-check-blue.svg);
    background-repeat: no-repeat;
}


.santi-guru .destacado,
.santi-guru a {
    color: #4D8D9A;
}

.santi-guru a:hover {
    color: #30565D;
}

/******** */

.santi-asistente .encabezado-santi span {
    color: #ac9568;
}

.santi-asistente .destacado,
.santi-asistente a {
    color: #755C2B;
}

.santi-asistente a:hover {
    color: #ac9568;
}

.bloque-flechas-rojas.santi-asistente::before {
    background-image: url(/img/adorno-flecha-izq-dorado.png);
}

.bloque-flechas-rojas.santi-asistente::after {
    background-image: url(/img/adorno-flecha-der-dorado.png);
}

.santi-asistente .list-checks__item::before {
    background-image: url(/img/icono-check-dorado.svg);
    background-repeat: no-repeat;
}
/*********/
.santi-vial .encabezado-santi span {
    color: #454545;
}

.santi-vial .destacado,
.santi-vial a {
    color: #454545;
}

.santi-vial a:hover {
    color: #454545;
}

.bloque-flechas-rojas.santi-vial::before {
    background-image: url(/img/adorno-flecha-izq-gris.png);
}

.bloque-flechas-rojas.santi-vial::after {
    background-image: url(/img/adorno-flecha-der-gris.png);
}

.santi-vial .list-checks__item::before {
    background-image: url(/img/icono-check-gris.png);
    background-repeat: no-repeat;
}
/*********/

/*********/
.santi-jale .encabezado-santi span {
    color: #87d4e3;
}

.santi-jale .destacado,
.santi-jale a {
    color: #87d4e3;
}

.santi-jale a:hover {
    color: #87d4e3;
}

.bloque-flechas-rojas.santi-jale::before {
    background-image: url(/img/adorno-flecha-izq-azul.png);
}

.bloque-flechas-rojas.santi-jale::after {
    background-image: url(/img/adorno-flecha-der-azul.png);
}

.santi-jale .list-checks__item::before {
    background-image: url(/img/icono-check-blue.svg);
    background-repeat: no-repeat;
}
/*********/
.santi-ecologico .encabezado-santi span {
    color: #12806e;
}

.santi-ecologico .destacado,
.santi-ecologico a {
    color: #12806e;
}

.santi-ecologico a:hover {
    color: #1CC0A5;
}

.bloque-flechas-rojas.santi-ecologico::before {
    background-image: url(/img/adorno-flecha-izq-verde.png);
}

.bloque-flechas-rojas.santi-ecologico::after {
    background-image: url(/img/adorno-flecha-der-verde.png);
}

.santi-ecologico .list-checks__item::before {
    background-image: url(/img/icono-check-green-svg.png);
    background-repeat: no-repeat;
}


/*********/

.santi-tabs {
    border-bottom: 1px solid #bebebe;
}

.santi-tabs a {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 44%, rgba(0, 0, 0, 9%) 64%);
    border: 1px solid #bebebe;
    border-radius: 10px 10px 0 0;
    display: flex;
    position: relative;
    top: 1px;
    text-align: center;
    color: #000;
    cursor: pointer;
    flex-direction: column;
    align-items: center;
}

.santi-tabs a.active {
    border-bottom: 1px solid #fff;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 44%, rgb(0 0 0 / 0%) 64%);
}

.santi-tabs span{
    line-height: 1rem;
    margin-bottom: 5px;
}

.santi-tabs img{
    width: 110px;
}
/****** */

.v-enter-active,
.v-leave-active {
    transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

@media (max-width: 576px) {
    .santi-tabs a span{
        font-size: .8em !important;
        line-height: 1rem !important;
    }
}
</style>
